<template>
  <v-container fluid pa-0>
    <v-layout row wrap>
      <v-flex xs12 sm12 md12  lg12 xl12 mx-4>
        <data-table
          :url="`/domains`"
          content="domainLists"
          :filters="filters"
          :dashboard="true"
          :limit="6"
          >
          <template slot="title">
            <v-layout justify-center align-center>
              <v-flex md10 class="headline">
                Dominios
              </v-flex>
              <v-flex md2>
                <v-btn v-if="checkCreate()" class="k-orange-linear white--text" block large @click="dialog = !dialog">
                  AGREGAR DOMINIO
                </v-btn>
              </v-flex>
            </v-layout>
          </template>
          <template slot="navigation-bar">
            <v-flex md12>
              <v-text-field solo label="Busqueda" color="grey" append-icon="fas fa-search" v-model="filters.search"></v-text-field>
            </v-flex>
          </template>
        </data-table>
        <save-dialog
          :title="title"
          :dialog="dialog"
          :form="form"
          :route="route"
          :edit="edit"
          :hasMore="false"
          :more="false"
          >
          <template slot="content">
            <v-layout row wrap>
              <v-flex xs12>
                <v-text-field
                v-model="form.domain"
                v-validate="'required'"
                data-vv-name="domain"
                data-vv-as="dominio"
                :error-messages="errors.collect('domain')"
                label="Dominio"
                color="black">
                </v-text-field>
              </v-flex>
            </v-layout>
          </template>
        </save-dialog>
        <delete-dialog
          :text="deleteOptions.text"
          :id="deleteOptions.id"
          :url="route"
          :dialog="deleteOptions.dialog"
          :delete-bus="deleteBus">
        </delete-dialog>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import Vue from 'vue';
import dataTable from '@/components/global/DataTable';
import domainLists from '@/components/domain/DomainList';
import saveDialog from '@/components/global/SaveDialog';
import saveDialogMixin from '@/mixins/saveDialog';
import deleteDialog from '@/components/global/DeleteDialog';
import deleteDialogMixin from '@/mixins/deleteDialog';
import permissionsMixin from '@/mixins/permissions';

Vue.component('domainLists', domainLists);

export default {
  inject: ['$validator'],
  mixins: [
    saveDialogMixin,
    deleteDialogMixin,
    permissionsMixin,
  ],
  components: {
    dataTable,
    saveDialog,
    deleteDialog,
  },
  data() {
    return {
      route: 'domains',
      showName: 'dominio',
      filters: {
        search: '',
      },
      form: {
        domain: '',
      },
    };
  },
  methods: {
    checkCreate(){
      return this.checkPermissions([
        'create_domains',
      ]);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/domain/Index.vue